<template>
  <div class="gsl-hrm-horizontal-padding gsl-hrm-vertical-padding">
    <oxd-text tag="h6" class="gsl-hrm-main-title">
      {{ $t('pim.edit_salary_deduction_component') }}
    </oxd-text>
    <oxd-divider />
    <oxd-form :loading="isLoading" @submit-valid="onSave">
      <oxd-form-row>
        <oxd-grid :cols="3" class="gsl-hrm-full-width-grid">
          <oxd-grid-item>
            <oxd-input-field
              v-model="salaryComponent.name"
              :label="$t('pim.salary_component')"
              :rules="rules.name"
              required
            />
          </oxd-grid-item>

          <oxd-grid-item>
            <oxd-input-field
              v-model="salaryComponent.amount"
              :label="$t('claim.amount')"
              :rules="rules.amount"
              required
            />
          </oxd-grid-item>
        </oxd-grid>
      </oxd-form-row>

      <oxd-form-actions>
        <required-text />
        <oxd-button
          type="button"
          display-type="ghost"
          :label="$t('general.cancel')"
          @click="onCancel"
        />
        <submit-button />
      </oxd-form-actions>
    </oxd-form>
  </div>
  <oxd-divider />
</template>

<script>
import {
  digitsOnlyWithDecimalPoint,
  maxCurrency,
  required,
  shouldNotExceedCharLength,
} from '@ohrm/core/util/validation/rules';

const salComponentModel = {
  name: '',
  amount: '',
};

export default {
  name: 'EditSalaryDeductionComponent',

  props: {
    http: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },

  emits: ['close'],

  data() {
    return {
      isLoading: false,
      salaryComponent: {...salComponentModel},
      rules: {
        name: [required, shouldNotExceedCharLength(100)],
        amount: [required, digitsOnlyWithDecimalPoint, maxCurrency(1000000000)],
      },
    };
  },

  beforeMount() {
    this.isLoading = true;
    this.http
      .get(this.data.id)
      .then((response) => {
        const {data} = response.data;
        this.salaryComponent.name = data.name;
        this.salaryComponent.amount = data.amount;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },

  methods: {
    onSave() {
      this.isLoading = true;

      this.http
        .update(this.data.id, {
          name: this.salaryComponent.name,
          amount: this.salaryComponent.amount,
        })
        .then(() => {
          return this.$toast.updateSuccess();
        })
        .then(() => {
          this.onCancel();
        });
    },
    onCancel() {
      this.$emit('close', true);
    },
  },
};
</script>

<style lang="scss" scoped>
.directdeposit-form-header {
  display: flex;
  padding: 1rem;
  &-text {
    font-size: 0.8rem;
    margin-right: 1rem;
  }
}
</style>
